export default "__VITE_ASSET__osWl16T4__"